import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Observable, Subject, timer } from 'rxjs';
import { repeatWhen, takeUntil } from 'rxjs/operators';
import { ButtonCoreComponent } from '../button-core/button-core.component';

import '@diekeure/dcr-components/dcr-focus-ring.js';
import '@diekeure/dcr-components/dcr-state-layer.js';

@Component({
  standalone: false,
  selector: 'campus-timer-button',
  templateUrl: './timer-button.component.html',
  styleUrls: ['./timer-button.component.scss'],
})
export class TimerButtonComponent extends ButtonCoreComponent implements OnInit, OnChanges, OnDestroy {
  private _timer: Observable<number>;

  private stop$ = new Subject();
  private start$ = new Subject();

  @HostBinding('class')
  defaultClasses = [
    ...this.coreClasses,
    'filled-button',

    'relative',
    'inline-flex',
    'primary-container',
    'w-fit',

    'border',
    'border-transparent',
    'outline-none',
    'corner-full',

    'disabled:border-stroke',
    'disabled:surface',

    'transition-all',
  ];

  @HostBinding('attr.data-has-leading-icon')
  @Input()
  leadingIcon: string;

  @HostBinding('attr.data-has-trailing-icon')
  @Input()
  trailingIcon: string;

  @HostBinding('style.--progress')
  @Input()
  progress: number;

  @Input()
  time: number;

  @Input()
  autoplay = true;

  @Input()
  refreshRate = 50;

  @Output()
  stopped = new EventEmitter<void>();

  @HostListener('click')
  onClick() {
    this.stopTimer();
  }

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this._timer = timer(0, this.refreshRate).pipe(
      takeUntil(this.stop$),
      repeatWhen(() => this.start$)
    );

    const step = 100 / (this.time / this.refreshRate);

    this._timer.subscribe(() => {
      if (this.progress >= 100) {
        this.stopTimer();
      }
      this.progress += step;

      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.stopTimer(false); // don't emit stopped twice
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.time) {
      if (this.autoplay) {
        this.progress = 0;
        this.startTimer();
      }
    }
  }

  stopTimer(emit = true) {
    this.stop$.next(undefined);
    if (emit) this.stopped.emit();
  }
  startTimer() {
    this.start$.next(undefined);
  }
}
